import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useGetProductsQuery } from "../../store/api/productsApi";
import {
  useCreateMovementMutation,
  useCreateProductOrderMutation,
  useGetLastGenIdQuery,
} from "../../store/api/movementApi";
import { useGetNotificationsQuery } from "../../store/api/notificationApi";
import Swal from "sweetalert2";
import { useGetConsumerQuery } from "../../store/api/consumerApi";
import { useGetBusinessQuery } from "../../store/api/businessApi";
import { useGetLastRequestGenIdQuery } from "../../store/api/RequestedMaterialsApi";
import Logo from "../tools/Logo";
import MaterialIssuePDFGenerator from "../tools/PDFMaterialIssueGenerator";
import { useGetUnitsQuery } from "../../store/api/UnitsApi";
import { useDrafts } from "../tools/useDrafts";

const initialFormData = {
  consumerName: "",
  productName: "",
  ProductsId: "",
  OrderQty: 0,
  consumerId: "",
  OrderPurpose: "",
  OrderType: "Consumed",
  amount: 0,
  UnitesId: "",
  UnitName: "",
  OrderDate: "",
};
export default function MateriaIssues() {
  const { drafts, handleUpdateDraft, handleRemoveDraft } =
    useDrafts("materialIssues");
  const { refetch: refetchNotifications } = useGetNotificationsQuery();
  const [dataBusiness, setBusinessData] = useState([]);
  let [getLastRequestGendId, setGetLastRequestGendId] = useState([]);
  const [suppId, setSupplierId] = useState(null);
  const [Description, setDescription] = useState("");
  const [Name, setName] = useState("");
  const [DateIssue, setDateIssue] = useState("");
  const [isSaved, setSaved] = useState(false);
  let [getLastId, setGetLastId] = useState(null);
  // Fetch Business
  const { data } = useGetBusinessQuery();
  useEffect(() => {
    if (data && Array.isArray(data)) {
      setBusinessData(data);
    }
  }, [data]);

  const [shouldExcludeLastRow, setShouldExcludeLastRow] = useState(false);
  const [createProductOrders] = useCreateProductOrderMutation();
  const [createMovement] = useCreateMovementMutation();

  const [products, setProducts] = useState([]);
  const [consumers, setConsumers] = useState([]);
  const [seletectedProductQty, setSeletectedProductQty] = useState(0);
  const [Units, setUnitsList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const [formData, setFormData] = useState(initialFormData);

  const [formDataList, setFormDataList] = useState([]);

  const { data: lastId, refetch: refetchLastId } = useGetLastGenIdQuery();

  const { data: UnitsList } = useGetUnitsQuery();

  const initializedRef = useRef(false);

  useEffect(() => {
    if (UnitsList) {
      setUnitsList(UnitsList);
    }
  }, [UnitsList]);

  useEffect(() => {
    if (lastId) {
      setGetLastId(lastId);
    }
  }, [lastId]);

  const { data: product, refetch: refetchProduct } = useGetProductsQuery({
    refetchOnMountOrArgChange: false,
  });
  useEffect(() => {
    if (product) {
      setProducts(product);
    }
  }, [product]);

  const { data: consumer } = useGetConsumerQuery({
    refetchOnMountOrArgChange: true,
  });
  useEffect(() => {
    if (consumer) {
      setConsumers(consumer);
    }
  }, [consumer]);

  const { data: lastRequestId } = useGetLastRequestGenIdQuery({
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (lastRequestId) {
      setGetLastRequestGendId(lastRequestId);
    }
  }, [lastRequestId]);

  useEffect(() => {
    if (drafts && drafts.length > 0 && !initializedRef.current) {
      setDescription(drafts.at(0)?.Description);
      setSupplierId(drafts.at(0)?.consumerId);
      setDateIssue(drafts.at(0)?.OrderDate);
      setFormData({
        ...formData,
        consumerId: drafts.at(0)?.consumerId,
        OrderPurpose: drafts.at(0)?.OrderPurpose,
        consumerName: drafts.at(0)?.consumerName,
        OrderDate: drafts.at(0)?.OrderDate,
      });
      setFormDataList([...drafts]);
      setSaved(true);

      initializedRef.current = true; // Mark as initialized
    }
  }, [drafts, getLastId]);

  const productOptions = products
    ?.filter((pro) => pro.isActive === "active" && pro.qty > 0)
    .map((pro) => ({
      value: pro.id,
      label: pro.name,
    }));

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "OrderPurpose") {
      setDescription(value);
    }

    if (name === "OrderDate") {
      setDateIssue(value);
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSelectChange = (Option) => {
    setSelectedOption(Option);

    if (Option != null) {
      const selectedProductId = parseInt(Option.value);
      const selectedProduct = products.find(
        (product) => product.id === selectedProductId
      );
      const selectedProductAmount = selectedProduct.amount;
      const selectedProductUnitesId = selectedProduct.unitesId;
      const selectedUnit = Units.find(
        (unit) => unit.id === selectedProductUnitesId
      );
      var selectedProductQty = selectedProduct.qty;
      setSeletectedProductQty(selectedProductQty);
      setFormData({
        ...formData,
        ProductsId: selectedProductId,
        productName: selectedProduct.name,
        UnitesId: selectedProductUnitesId,
        UnitName: selectedUnit.name,
        supplierId: null,
        consumerId: null,
        amount: selectedProductAmount,
      });
    }
  };

  const handleConsumerSelectChange = (name, selectedOption) => {
    const selectConsumerId = parseInt(selectedOption.target.value);
    const selectedConsumer = consumers.find(
      (con) => con.id === selectConsumerId
    );
    setSupplierId(selectConsumerId);
    setName(selectedConsumer.name);
    setFormData({
      ...formData,
      [name]: selectedOption.target.value,
      consumerName: selectedConsumer.name,
    });
  };

  function getGreatestId(ids) {
    let maxNumericPart = -Infinity;
    let maxFullId = null;

    ids.forEach((id) => {
      if (id) {
        const parts = id.split("-");
        const numericPart = parseInt(parts[parts.length - 1], 10);

        if (!isNaN(numericPart) && numericPart > maxNumericPart) {
          maxNumericPart = numericPart;
          maxFullId = id;
        }
      }
    });

    // Check if both IDs were null or undefined
    if (ids.every((id) => id === null || id === undefined)) {
      return null;
    }

    return maxFullId;
  }

  const handleAddToList = async () => {
    setSaved(true);
    const isProductExists = formDataList.some(
      (data) => data.productName === formData.productName
    );

    if (isProductExists) {
      updateQuantities(formDataList, formData);
    } else if (Object.values(formData).some((value) => value === "")) {
      Swal.fire({
        title: "Please fill in all fields 📥.",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
      });
    } else {
      if (formData.OrderQty <= 0) {
        Swal.fire("Invalid Quantity or insufficient quantity");
      } else if (formData.OrderQty > seletectedProductQty) {
        Swal.fire("insufficient quantity");
      } else {
        setFormDataList([
          ...formDataList,
          { ...formData, consumerId: suppId, OrderPurpose: Description },
        ]);
        handleUpdateDraft("OrderQty", { ...formData, consumerId: suppId });
        setFormData({
          consumerName: Name,
          productName: "",
          ProductsId: "",
          OrderQty: 0,
          consumerId: suppId,
          OrderPurpose: Description,
          OrderType: "Consumed",
          OrderDate: DateIssue,
          amount: 0,
          UnitesId: "",
          UnitName: "",
        });
        setSeletectedProductQty(0);
        setSelectedOption(null);
      }
    }
  };

  const updateQuantities = (formDataList, formData) => {
    console.log(formData);

    const oldProduct = formDataList.filter(
      (data) => data.productName === formData.productName
    );

    if (seletectedProductQty == parseInt(oldProduct.at(0).OrderQty)) {
      Swal.fire("insufficient Quantity");
      setFormData({
        consumerName: Name,
        productName: "",
        ProductsId: "",
        OrderQty: 0,
        consumerId: suppId,
        OrderPurpose: Description,
        OrderType: "Consumed",
        amount: 0,
        UnitesId: "",
        UnitName: "",
      });
      setSeletectedProductQty(0);
      setSelectedOption(null);
    } else {
      oldProduct.at(0).OrderQty =
        parseInt(oldProduct.at(0).OrderQty) + parseInt(formData.OrderQty);
      const oldFormDataList = formDataList.filter(
        (data) => data.productName !== formData.productName
      );
      setFormDataList([...oldFormDataList, ...oldProduct]);
      handleUpdateDraft("OrderQty", { ...formData, consumerId: suppId });
      setFormData({
        consumerName: Name,
        productName: "",
        ProductsId: "",
        OrderQty: 0,
        consumerId: suppId,
        OrderPurpose: Description,
        OrderType: "Consumed",
        amount: 0,
        UnitesId: "",
        UnitName: "",
      });
      setSeletectedProductQty(0);
      setSelectedOption(null);
    }
  };

  const handleRemove = (e, row) => {
    e.preventDefault();
    handleRemoveDraft(row.ProductsId);
    const newData = formDataList.filter((item) => item !== row);
    if (newData.length > 0) {
      setFormDataList(newData);
    } else {
      setFormDataList([]);
      setFormData(initialFormData);
      setSaved(false);
    }
  };

  // const formatDate = () => {
  //   const date = new Date();
  //   return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  // };

  const generateUniqueId = (name, length, getLastIds) => {
    let lastNumber = 100;
    let randomString = "";
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    if (getLastIds) {
      if (getLastIds && getLastIds.trim() !== "") {
        const index = getLastIds.lastIndexOf("-");
        const lastPart = getLastIds.substring(index + 1);

        lastNumber = parseInt(lastPart, 10);
        if (!isNaN(lastNumber)) {
          lastNumber++;
        }
      }
    }

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      randomString += chars[randomIndex];
    }
    let gen = `${name}-${randomString}-${lastNumber}`;
    return gen;
  };

  // const RestData = () => {
  //   setSeletectedProductQty(null);
  //   localStorage.removeItem('materialIssues');
  //   setFormDataList([]);
  //   setFormData(initialFormData);
  //   setSaved(false)
  // }

  const createProductOrder = async () => {
    var data = formDataList?.length > 0 ? formDataList[0] : {};
    const userData = JSON.parse(localStorage.getItem("UserData"));
    const userId = userData ? userData.id : null;
    const generateId = generateUniqueId(
      "PLM",
      6,
      getGreatestId([getLastId?.genId, getLastRequestGendId?.genId])
    );
    const orderData = {
      Id: 0,
      consumerId: data.consumerId,
      supplierId: null,
      orderType: "Consumed",
      GenId: generateId,
      OrderDate: data.OrderDate,
      UsersId: userId,
    };

    const savedOrderData = await createProductOrders(orderData);

    return savedOrderData;
  };

  const handlCreateMaterialIssue = async (type, event) => {
    setShouldExcludeLastRow(!shouldExcludeLastRow);

    event.preventDefault();
    let allSuccess = true;
    let msg = "";

    const productOrderResponse = await createProductOrder();

    if (productOrderResponse.data.status === 200) {
      for (const item of formDataList) {
        const movementResponse = await createMovement({
          ...item,
          GenId: productOrderResponse.data.orders?.genId,
          ProductOrderId: productOrderResponse.data.orders?.id,
        });

        if (movementResponse.data.status !== 200) {
          allSuccess = false;
          msg = movementResponse.data.message;
          break;
        } else {
          msg = movementResponse.data.message;
          setShouldExcludeLastRow(!shouldExcludeLastRow);
        }
      }

      await refetchNotifications();
      await refetchLastId();

      if (allSuccess) {
        if (type === "download") {
          MaterialIssuePDFGenerator(
            productOrderResponse.data.orders?.genId,
            formDataList
          );
        }
        setFormDataList([]);
        setShouldExcludeLastRow(!shouldExcludeLastRow);

        Swal.fire({
          title: "Success!",
          text: msg,
          icon: "success",
          confirmButtonText: "Done",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: msg,
          icon: "error",
          confirmButtonText: "Close",
        });
      }
    }
    await refetchProduct();
    localStorage.removeItem("materialIssues");
    setFormDataList([]);
    setFormData(initialFormData);
    setSaved(false);
  };

  const ConfirmHandle = async (type, event) => {
    event.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${type} the selected material issue?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#022B3A",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        handlCreateMaterialIssue(type, event);
      }
    });
  };

  const RestData = (e, type) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} the selected material issue? !!!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#022B3A",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        setSeletectedProductQty(null);
        localStorage.removeItem("materialIssues");
        setFormDataList([]);
        setFormData(initialFormData);
        setSaved(false);
      }
    });
  };

  const canSave = [
    formData.ProductsId,
    formData.OrderQty,
    formData.OrderType,
    formData.UnitesId,
    formData.OrderPurpose,
  ].every(Boolean);

  const createPage = () => {
    if (formDataList.length === 0) {
      return (
        <div className="text-center fs-4 text-muted mt-5">
          Invoice goes here
        </div>
      );
    }

    const startIndex = 0;
    //const endIndex = Math.min(8, formDataList.length);
    const endIndex = formDataList.length;
    const pageData = formDataList.slice(startIndex, endIndex);

    return (
      <div
        className="d-flex flex-column justify-content-start position-relative "
        style={{
          height: "18cm",
        }}
      >
        <div className="table-responsive" style={{ overflowX: "auto" }}>
          <table className="table table-striped" style={{ minWidth: "600px" }}>
            <thead className="table-dark p-0">
              <tr>
                <th className="text-lowercase text-center" colspan="2">
                  Name
                </th>
                <th className="text-lowercase text-center">Quantity</th>
                <th className="font-size-h6 text-center">Unit</th>
                <th className="text-lowercase text-center" colspan="2">
                  Issue Type
                </th>

                <th className="text-lowercase text-center">Price</th>
                <th className="text-lowercase text-center">Total</th>
                <th className={shouldExcludeLastRow ? "d-none" : "text-center"}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {pageData.map((item, index) => (
                <>
                  <tr key={index}>
                    <td className="text-lowercase" colspan="2">
                      {item.productName}
                    </td>
                    <td className="text-center">{item.OrderQty}</td>
                    <td className="text-center">{item.UnitName}</td>
                    <td colspan="2" className="text-center">
                      {item.OrderType.replace(/([a-z])([A-Z])/g, "$1 $2")}
                    </td>

                    <td className="text-center">${item.amount}</td>
                    <td className="text-center">
                      ${item.amount * item.OrderQty}
                    </td>

                    <td
                      className={
                        shouldExcludeLastRow ? "d-none" : "text-center"
                      }
                    >
                      <button
                        className={
                          shouldExcludeLastRow
                            ? "d-none"
                            : "btn bg-danger text-white"
                        }
                        onClick={(e) => handleRemove(e, item)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="block1 m-2 p-1">
        <div className="row border-bottom">
          <div className="col-lg-4 col-md-6 col-sm-3 col-12 mb-2 fs-3">
            Material Issuing
          </div>
        </div>

        <div className="row p-2">
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-12">
            <div className="row mt-4">
              <div className="mt-2">
                <div className="mb-3">
                  <div className="row">
                    <label
                      htmlFor="SelectFaculty"
                      className="form-label text-start"
                    >
                      Consumers
                    </label>
                  </div>
                  <select
                    disabled={isSaved}
                    className="form-select"
                    style={{ height: "45px" }}
                    aria-label="Default select example"
                    id="SelectFaculty"
                    onChange={(e) =>
                      handleConsumerSelectChange("consumerId", e)
                    }
                    value={
                      formData.consumerId === 0
                        ? "Select Consumer"
                        : formData.consumerId
                    }
                  >
                    <option selected>Select Consumer</option>
                    {consumers?.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mt-2">
                <div className="row">
                  <label
                    htmlFor="notificationQuantity"
                    className="form-label text-start"
                  >
                    Purpose?
                  </label>
                </div>
                <textarea
                  disabled={isSaved}
                  className="form-control "
                  name="OrderPurpose"
                  placeholder="write here the reason for consuming"
                  value={formData.OrderPurpose}
                  onChange={handleFormChange}
                />
              </div>

              <div className="col-sm-12">
                <div className="mt-2">
                  <div className="row">
                    <label
                      htmlFor="exampleDateOfBirth"
                      className="form-label text-start"
                    >
                      Date Issue
                    </label>
                  </div>
                  <input
                    disabled={isSaved}
                    style={{ height: "45px" }}
                    name="OrderDate"
                    type="datetime-local"
                    className="form-control"
                    id="exampleDateOfBirth"
                    max={new Date().toISOString().slice(0, 16)}
                    value={formData.OrderDate}
                    autoComplete="off"
                    onChange={handleFormChange}
                  />
                </div>
              </div>

              <div className="mt-2">
                <div className="mb-3">
                  <div className="row">
                    <label
                      htmlFor="SelectProduct"
                      className="form-label text-start"
                    >
                      Products{" "}
                      {seletectedProductQty > 0 ? (
                        <span className={"text-primary fs-6 mx-2"}>
                          The selected product quantity is{" "}
                          {seletectedProductQty}
                        </span>
                      ) : (
                        ""
                      )}
                    </label>
                  </div>

                  <div className="d-flex mb-3">
                    <div className="input-group flex-grow-1 me-2">
                      <Select
                        className="w-100"
                        name="ProductsId"
                        inputId="SelectProduct"
                        options={productOptions}
                        onChange={handleSelectChange}
                        value={selectedOption}
                        placeholder="Select Product"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            height: "40px",
                            minHeight: "40px",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>
                    <div className="input-group" style={{ width: "150px" }}>
                      <select
                        disabled={true}
                        className="form-control"
                        style={{ height: "40px" }}
                        aria-label="Default select example"
                        id="SelectUnits"
                        name="UnitesId"
                        onChange={handleFormChange}
                        value={formData.UnitesId || 0}
                      >
                        <option value={0}>Units</option>
                        {Units.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 mt-2">
                <div className="row">
                  <label
                    htmlFor="notificationQuantity"
                    className="form-label text-start"
                  >
                    How many quantity he/she wants to consume?
                  </label>
                </div>
                <div className="input-group">
                  <input
                    name="OrderQty"
                    style={{ height: "45px" }}
                    type="number"
                    min={"0"}
                    className="form-control numericInput"
                    id="notificationQuantity"
                    value={formData.OrderQty}
                    onChange={handleFormChange}
                  />
                </div>
                <span
                  className={
                    formData.OrderQty > seletectedProductQty
                      ? "text-danger"
                      : "d-none"
                  }
                >
                  invalid quantity, you have to order less or equal to{" "}
                  {formData.quantity}
                </span>
              </div>

              <div className="text-end ">
                <button
                  disabled={
                    formData.OrderQty > seletectedProductQty ||
                    formData.OrderQty <= 0
                      ? true
                      : false || !canSave
                  }
                  type="submit"
                  className="btn btn-primary mt-2 px-3 pe-3 pt-2 pb-2 mt-3 mb-sm-5"
                  onClick={handleAddToList}
                >
                  Add To The List
                </button>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-12">
            <div className="mt-3 mb-3">
              {formDataList.length > 0 ? (
                <div className="d-flex justify-content-end">
                  <div className="me-2">
                    <button
                      title="Clear"
                      onClick={(e) => RestData(e, "Clear")}
                      className="btn btn-secondary p-2"
                    >
                      <Logo
                        _width={25}
                        name={"../image/icons/clear-01.svg"}
                        _height={25}
                        _color={"#FFFFFF"}
                      />
                    </button>
                  </div>

                  <div className="me-2">
                    <button
                      title="Download"
                      onClick={(e) => ConfirmHandle("download", e)}
                      className="btn btn-secondary p-2"
                    >
                      <Logo
                        _width={25}
                        name={"../image/icons/download.svg"}
                        _height={25}
                        _color={"#FFFFFF"}
                      />
                    </button>
                  </div>

                  <div className="me-3">
                    <button
                      title="Save"
                      onClick={(e) => ConfirmHandle("save", e)}
                      className="btn btn-success p-2"
                    >
                      <Logo
                        _width={25}
                        name={"../image/icons/save.svg"}
                        _height={25}
                        _color={"#FFFFFF"}
                      />
                    </button>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>

            <div className="position-relative">{createPage()}</div>
          </div>
        </div>
      </div>
    </>
  );
}
